import {
  createBidComments$,
  createDailyLogComment$, createMeetingMinutesComment$,
  createProjectComments$,
  createPunchComment$,
  createRfiComment$,
  createSubmittalComment$,
  createTaskComment$,
  getBidComments$,
  getDailyLogComments$,
  getMeetingMinutesComments$,
  getProjectComments$,
  getPunchComments$,
  getRfiComments$,
  getSubmittalComments$,
  getTaskComments$
} from "../services/comments";
import {networkError} from "./ui";
import * as R from 'ramda';
import {convertToDate} from "../projections";

export const ADD_PROJECT_COMMENTS = 'ADD_PROJECT_COMMENTS';
export const addProjectComments = (projectId, chats) => ({type: ADD_PROJECT_COMMENTS, payload: {projectId, chats}});
export const ADD_BID_COMMENTS = 'ADD_BID_COMMENTS';
export const addBidComments = (bidId, chats) => ({type: ADD_BID_COMMENTS, payload: {bidId, chats}});
export const ADD_MEETING_MINUTES_COMMENTS = 'ADD_MEETING_MINUTES_COMMENTS';
export const addMeetingMinutesComments = (projectId, meetingId, chats) => ({type: ADD_MEETING_MINUTES_COMMENTS, payload: {projectId, meetingId, chats}});
export const ADD_DAILY_LOG_COMMENTS = 'ADD_DAILY_LOG_COMMENTS';
export const addDailyLogComments = (projectId, logId, chats) => ({type: ADD_DAILY_LOG_COMMENTS, payload: {projectId, logId, chats}});
export const ADD_PUNCH_LIST_COMMENTS = 'ADD_PUNCH_LIST_COMMENTS';
export const addPunchListComments = (projectId, punchId, chats) => ({type: ADD_PUNCH_LIST_COMMENTS, payload: {projectId, punchId, chats}});
export const ADD_RFI_COMMENTS = 'ADD_RFI_COMMENTS';
export const addRfiComments = (projectId, rfiId, chats) => ({type: ADD_RFI_COMMENTS, payload: {projectId, rfiId, chats}});
export const ADD_SUBMITTAL_COMMENTS = 'ADD_SUBMITTAL_COMMENTS';
export const addSubmittalComments = (projectId, submittalId, chats) => ({type: ADD_SUBMITTAL_COMMENTS, payload: {projectId, submittalId, chats}});
export const ADD_TASK_COMMENTS = 'ADD_TASK_COMMENTS';
export const addTaskComments = (projectId, taskId, chats) => ({type: ADD_TASK_COMMENTS, payload: {projectId, taskId, chats}});

const translateDateCreated = R.over(R.lensProp('datecreated'), convertToDate);
const resultFieldMap = results => results.map(translateDateCreated);

export const loadBidComments = (bidId) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getBidComments$({bidId, offset: nextOffset}).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addBidComments(bidId, resultFieldMap(results)));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10017-'+error.status}));
  }
};

export const loadProjectComments = (projectId) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getProjectComments$({projectId}).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addProjectComments(projectId, resultFieldMap(results)));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10018-'+error.status}));
  }
};

export const loadMeetingMinutesComments = (projectId, meetingId) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getMeetingMinutesComments$({ projectId, meetingId: meetingId }).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addMeetingMinutesComments(projectId, meetingId, resultFieldMap(results)));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10019-'+error.status}));
  }
};

export const loadDailyLogComments = (projectId, logId) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getDailyLogComments$({ projectId, logId }).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addDailyLogComments(projectId, logId, resultFieldMap(results)));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10019-'+error.status}));
  }
};

export const loadPunchListComments = (projectId, punchId) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getPunchComments$({ projectId, punchId }).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addPunchListComments(projectId, punchId, resultFieldMap(results)));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10020-'+error.status}));
  }
};

export const loadRfiComments = (projectId, rfiId) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getRfiComments$({ projectId, rfiId }).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addRfiComments(projectId, rfiId, resultFieldMap(results)));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10021-'+error.status}));
  }
};

export const loadSubmittalComments = (projectId, submittalId) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getSubmittalComments$({ projectId, submittalId }).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addSubmittalComments(projectId, submittalId, resultFieldMap(results)));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10022-'+error.status}));
  }
};

export const loadTaskComments = (projectId, taskId) => async (dispatch, getState) => {
  try {
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let {response, status} = await getTaskComments$({ projectId, taskId }).toPromise();
      if (status === 204) return;
      if (response === null) return;
      let { results, offset, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) {
        dispatch(addTaskComments(projectId, taskId, resultFieldMap(results)));
        nextOffset = R.last(results).id;
      }
    } while (soFar < theSize);
  } catch (error) {
    dispatch(networkError({...error, number: '10023-'+error.status}));
  }
};

export const sendBidComment = (bidId, comment) => async (dispatch, getState) => {
  try {
    let { response, status } = await createBidComments$({ bidId, comment }).toPromise();
    dispatch(loadBidComments(bidId));
  } catch (error) {
    dispatch(networkError({...error, number: '10024-'+error.status}));
  }
};

export const sendProjectComment = (projectId, comment) => async (dispatch, getState) => {
  try {
    let { response, status } = await createProjectComments$({ projectId, comment }).toPromise();
    dispatch(loadProjectComments(projectId));
  } catch (error) {
    dispatch(networkError({...error, number: '10025-'+error.status}));
  }
};

export const sendMeetingMinutesComment = (projectId, meetingId, comment) => async (dispatch, getState) => {
  try {
    let { response, status } = await createMeetingMinutesComment$({ projectId, meetingId, comment }).toPromise();
    dispatch(loadMeetingMinutesComments(projectId, meetingId));
  } catch (error) {
    dispatch(networkError({...error, number: '10026-'+error.status}));
  }
};

export const sendDailyLogComment = (projectId, logId, comment) => async (dispatch, getState) => {
  try {
    let { response, status } = await createDailyLogComment$({ projectId, logId, comment }).toPromise();
    dispatch(loadDailyLogComments(projectId, logId));
  } catch (error) {
    dispatch(networkError({...error, number: '10026-'+error.status}));
  }
};

export const sendPunchComment = (projectId, punchId, comment) => async (dispatch, getState) => {
  try {
    let { response, status } = await createPunchComment$({ projectId, punchId, comment }).toPromise();
    dispatch(loadPunchListComments(projectId, punchId));
  } catch (error) {
    dispatch(networkError({...error, number: '10027-'+error.status}));
  }
};

export const sendSubmittalComment = (projectId, submittalId, comment) => async (dispatch, getState) => {
  try {
    let { response, status } = await createSubmittalComment$({ projectId, submittalId, comment }).toPromise();
    dispatch(loadSubmittalComments(projectId, submittalId));
  } catch (error) {
    dispatch(networkError({...error, number: '10028-'+error.status}));
  }
};

export const sendRfiComment = (projectId, rfiId, comment) => async (dispatch, getState) => {
  try {
    let { response, status } = await createRfiComment$({ projectId, rfiId, comment }).toPromise();
    dispatch(loadRfiComments(projectId, rfiId));
  } catch (error) {
    dispatch(networkError({...error, number: '10029-'+error.status}));
  }
};

export const sendTaskComment = (projectId, taskId, comment) => async (dispatch, getState) => {
  try {
    let { response, status } = await createTaskComment$({ projectId, taskId, comment }).toPromise();
    dispatch(loadTaskComments(projectId, taskId));
  } catch (error) {
    dispatch(networkError({...error, number: '10030-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/comments.js